import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class CustomerConnectionService {
    baseurl = environment.apiBaseUrl;

    constructor(protected http: HttpClient) {
    }

    getCustomerConnections(pipelineId: any) {
        return this.http.get<any[]>(this.baseurl + 'pipeline/getcustomerconnections/' + pipelineId);
    }

    addCustomerConnection(customerconnection: any) {
        return this.http.post<any[]>(this.baseurl + 'pipeline/addcustomerconnection', customerconnection)
    }

    updateCustomerConnection(customerconnection: any) {
        return this.http.post<any[]>(this.baseurl + 'pipeline/updatecustomerconnection', customerconnection)
    }

    deleteCustomerConnection(customerConnectionId: any){
        return this.http.delete<any>(this.baseurl + 'pipeline/deletecustomerconnection/'+customerConnectionId)
    }
}